import { Skeleton, Stack } from '@mui/material';

export const HomePageSidebarNotificationLoadingState: React.FC = () => {
  return (
    <Stack
      height="100%"
      gap={2}
    >
      {Array.from({ length: 6 }).map(() => (
        <Skeleton
          key={crypto.randomUUID()}
          variant="rounded"
          height="150px"
          sx={{
            marginX: 2,
          }}
        />
      ))}
    </Stack>
  );
};